const setObjectIdentifiers = (object, apiObject) => {
  if (!apiObject) return object
  const { sfid, id } = apiObject
  return { ...object, sfid, id }
}

export default setObjectIdentifiers
